import React, { useRef, useState } from "react";
import ContentCopy from "../../assets/images/content_copy.svg";
import CheckCircleFilled from "../../assets/images/incl.svg";
import { FlexDiv } from "../../assets/styles/style";
import {
  CardInfoName,
  CTCimg3,
  PaymentCardBtn,
  PaymentCardWhiteBtn,
} from "./style";

const detailRowStyle = {
  width: "100%",
  justifyContent: "space-between",
  gap: "1rem",
  padding: "0.85rem 0",
  borderBottom: "1px solid #eceaf2",
};

const PaymentConfirmedPopup = ({
  confirmation,
  onDashboard,
  onViewTransactions,
}) => {
  const [copied, setCopied] = useState(false);
  const referenceRef = useRef(null);

  const copyReference = async () => {
    if (!confirmation.referenceNumber) return;
    try {
      await navigator.clipboard.writeText(confirmation.referenceNumber);
      setCopied(true);
      setTimeout(() => setCopied(false), 1000);
    } catch (error) {
      console.error("Failed to copy reference:", error);
    }
  };

  return (
    <FlexDiv
      style={{
        width: "100%",
        minHeight: "calc(100vh - 5rem)",
        padding: "7rem 1rem 3rem",
        boxSizing: "border-box",
        alignItems: "center",
      }}
    >
      <FlexDiv
        style={{
          width: "100%",
          maxWidth: "35rem",
          flexDirection: "column",
          alignItems: "center",
          background: "#fff",
          border: "1px solid #e5e1ef",
          borderRadius: "0.5rem",
          padding: "2rem",
          boxShadow: "0 12px 30px rgba(22, 22, 30, 0.08)",
        }}
      >
        <img src={CheckCircleFilled} alt="" style={{ width: "3.5rem" }} />
        <h1 style={{ fontSize: "1.5rem", margin: "1rem 0 0.5rem" }}>
          Receipt submitted
        </h1>
        <div
          style={{
            color: "#8a5a00",
            background: "#fff6df",
            border: "1px solid #f1d89c",
            borderRadius: "1rem",
            padding: "0.35rem 0.75rem",
            fontWeight: 600,
            fontSize: "0.875rem",
          }}
        >
          Pending approval
        </div>
        <p
          style={{
            color: "#65616f",
            textAlign: "center",
            lineHeight: 1.5,
            margin: "1rem 0 1.25rem",
          }}
        >
          We received your payment receipt. Your subscription will be activated
          after the payment is reviewed.
        </p>

        <FlexDiv style={{ width: "100%", flexDirection: "column" }}>
          <FlexDiv style={detailRowStyle}>
            <span style={{ color: "#777280" }}>Plan</span>
            <strong style={{ textAlign: "right" }}>{confirmation.planName}</strong>
          </FlexDiv>
          {confirmation.referenceNumber && (
            <FlexDiv style={detailRowStyle}>
              <span style={{ color: "#777280" }}>Reference</span>
              <FlexDiv style={{ gap: "0.5rem" }}>
                <CardInfoName ref={referenceRef}>{confirmation.referenceNumber}</CardInfoName>
                <CTCimg3
                  src={ContentCopy}
                  alt={copied ? "Copied" : "Copy reference"}
                  clicked={copied}
                  onClick={copyReference}
                  style={{ cursor: "pointer" }}
                />
              </FlexDiv>
            </FlexDiv>
          )}
          {confirmation.transactionId && (
            <FlexDiv style={{ ...detailRowStyle, borderBottom: "none" }}>
              <span style={{ color: "#777280" }}>Transaction ID</span>
              <strong>{confirmation.transactionId}</strong>
            </FlexDiv>
          )}
        </FlexDiv>

        <FlexDiv
          style={{
            width: "100%",
            gap: "0.75rem",
            flexWrap: "wrap",
            marginTop: "1.5rem",
          }}
        >
          <PaymentCardBtn style={{ flex: "1 1 13rem" }} onClick={onViewTransactions}>
            View transactions
          </PaymentCardBtn>
          <PaymentCardWhiteBtn style={{ flex: "1 1 13rem" }} onClick={onDashboard}>
            Go to dashboard
          </PaymentCardWhiteBtn>
        </FlexDiv>
      </FlexDiv>
    </FlexDiv>
  );
};

export default PaymentConfirmedPopup;
